import authSlice from 'redux/slices/auth';
import profileSlice from 'redux/slices/profile';
import outletSlice from 'redux/slices/outlet';

export default {
    ...authSlice.actions,
    ...profileSlice.actions,
    ...outletSlice.actions,
};
